import { render, staticRenderFns } from "./StudentEditTabSecret.vue?vue&type=template&id=06ceec34&"
import script from "./StudentEditTabSecret.vue?vue&type=script&lang=js&"
export * from "./StudentEditTabSecret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports